import React, { useState, useEffect, useRef } from 'react'
import { PaperPlaneIcon, XIcon } from '@phosphor-icons/react'
import { useOnboarding } from 'context/onboarding.context'
import { ASSET_CLASSES, CLASS_LABELS } from 'utilities/global.variables'

import './onboarding.modal.css'



// ─── Modal ───

const OnboardingModal = ({ onDismiss }) => {
  const { onboarding, setOnboarding, startOnboarding } = useOnboarding()

  // CHAT

  const [messages, setMessages] = useState([])
  const [question, setQuestion] = useState(null)
  const [value, setValue] = useState('')
  const [answers, setAnswers] = useState({})

  // QUESTIONS

  const q_valuations = {
    id: 'q_valuations',
    messages: [
      { id:'valuations1', type: 'bot', content: 'An amazing start! Pocketwatch groups assets into: Properties, Pensions, Investments, Savings and Other' },
      { id:'valuations2', type: 'bot', content: '(we\'ve already done this for you already)' },
      { id:'valuations3', type: 'bot', content: 'Let’s put some numbers to these' },
      { id:'valuations4', type: 'bot', content: 'What are your assets worth?' },
    ],
    input: {
      type: 'number-group',
      options: (a) => [...(a.q_assets || [])].sort((x, y) => {
        const classOf = (label) => q_assets.input.options.find(o => o.label === label)?.class
        return ASSET_CLASSES.indexOf(classOf(x)) - ASSET_CLASSES.indexOf(classOf(y))
      })
    },
    next_q: null
  }

  const q_assets = {
    id: 'q_assets',
    messages: [
      { id:'assets1', type: 'bot', content: 'Perfect, now into your portfolio' },
      { id:'assets2', type: 'bot', content: 'Which of these assets do you currently own?' },
      { id:'assets3', type: 'bot', content: 'Don\'t worry if your asset isn\'t shown, you\'ll have a chance to add it later.' },
    ],
    input: {
      type: 'checkbox',
      options: [
        { label: 'House', class: 'Property' },
        { label: 'Flat', class: 'Property' },
        { label: 'Buy to let', class: 'Property' },
        { label: 'Work pension', class: 'Pension' },
        { label: 'Personal pension', class: 'Pension' },
        { label: 'Cash ISA', class: 'Investment' },
        { label: 'Stocks and shares ISA', class: 'Investment' },
        { label: 'LISA', class: 'Investment' },
        { label: 'Term deposit', class: 'Savings' },
        { label: 'Premium bonds', class: 'Savings' },
        { label: 'Savings', class: 'Savings' },
        { label: 'Cash', class: 'Other' },
      ]
    },
    next_q: q_valuations
  }

  const q_location = {
    id: 'q_location',
    messages: [
      { id:'location1', type: 'bot', content: 'Nice. And where are you based?' },
    ],
    input: { type: 'radio', options: ['UK', 'Elsewhere in the world'] },
    next_q: q_assets
  }

  const q_joint = {
    id: 'q_joint',
    messages: [
      { id:'joint1', type: 'bot', content: 'Great! Are you tracking your wealth solo, or with a partner?' },
    ],
    input: { type: 'radio', options: ['Solo', 'Joint'] },
    next_q: q_location
  }

  const q_generation = {
    id: 'q_generation',
    messages: [
      { id:'generation1', type: 'bot', content: (a) => `Hi${a.q_display_name ? ' '+a.q_display_name : ''}, welcome to PocketWatch` },
      { id:'generation2', type: 'bot', content: 'What stage of the wealth journey are you on?' },
    ],
    input: { type: 'radio', options: ['Creating wealth (13-28)', 'Building wealth (29-44)', 'Maximising wealth (44-59)', 'Managing wealth (60+)'] },
    onboarding_key: 'generation',
    next_q: q_joint
  }

  const q_display_name = {
    id: 'q_display_name',
    messages: [

      { id:'name2', type: 'bot', content: 'Hey. Let’s get you set up.' },
      {id:'name3', type: 'bot', content: 'Firstly, what should we call you?' }
    ],
    input: { type: 'text', placeholder: 'Your name' },
    onboarding_key: 'display_name',
    next_q: q_generation,
  }

  // Sets the active question and pushes its messages onto the onboarding messages.
  const selectNext = (q, resolvedAnswers = answers) => {
    setQuestion(q)
    if (q.input.type === 'checkbox') {
      setValue([])
    } else if (q.input.type === 'number-group') {
      const options = typeof q.input.options === 'function' ? q.input.options(resolvedAnswers) : q.input.options
      setValue(Object.fromEntries(options.map(opt => [opt, ''])))
    } else {
      setValue('')
    }
    setMessages(prev => [...prev, ...q.messages])
  }

  const setNumberGroupValue = (opt, amount) => {
    setValue(prev => ({ ...prev, [opt]: amount }))
  }

  const toggleCheckbox = (opt) => {
    setValue(prev => prev.includes(opt) ? prev.filter(v => v !== opt) : [...prev, opt])
  }

  const selectBack = () => {

  }

  const selectSkip = () => {

  }






  // const submitName = value => {
  //   setOnboarding(prev => ({ ...prev, display_name: value }))
  //   console.log(onboarding)
  // }


  const handleSubmit = e => {
    e.preventDefault()

    const content = Array.isArray(value)
      ? value.join(', ')
      : (value && typeof value === 'object'
        ? Object.entries(value).map(([opt, amount]) => `${opt}: ${amount || 0}`).join(', ')
        : value)

    setMessages(prev => [...prev, { id: `${question.messages.at(-1).id}-answer`, type: 'user', content }])

    // if (question.id) {
    //         setAnswers(prev => ({ ...prev, [question.id]: value }))

    // }

    // if (question.onboarding_key) {
    //   setOnboarding(prev => ({ ...prev, [question.onboarding_key]: value }))
    // }

    if (question.next_q) {
      const nextAnswers = { ...answers, [question.id]: value }
      setTimeout(() => (
      selectNext(question.next_q, nextAnswers),
      setAnswers(nextAnswers),
      setOnboarding(prev => ({ ...prev, [question.onboarding_key]: value }))

      ),  250)
    }
  }

  const bottomRef = useRef(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  const initialised = useRef(false)

  useEffect(() => {
    if (initialised.current) return
    initialised.current = true
    startOnboarding()
    selectNext(q_display_name)
  }, [])





  return (
    <div className='ModalBackground'>
      <div
        className='Onboarding card '
     
      >
        <div className='flex row space center'>
          <p></p>
          <p className='xlarge'>Welcome aboard</p>
          <div>
          {/* <button className='ContinueLaterButton' onClick={onDismiss}> */}
            <XIcon size={18} weight='bold' onClick={onDismiss} />
          {/* </button> */}
          </div>
        </div>

        <div className='Messages margin-top-large'>
          {messages.map(msg => (
            <div
              key={msg.id}
              className={msg.type === 'bot' ? 'bot' : 'user'}
            >
          
              <p className='large'>{typeof msg.content === 'function' ? msg.content(answers) : msg.content}</p>{' '}
            </div>
          ))}
          <div ref={bottomRef} />
        </div>

    
          <form className='UserInput' onSubmit={handleSubmit}>
            {question?.input.type === 'text' && (
              <>
              <input
                type='text'
                value={value}
                onChange={e => setValue(e.target.value)}
                placeholder={question.input.placeholder}
                autoFocus
                maxLength={30}
              />
                          </>

            )}

            {question?.input.type === 'radio' && (
              <div className='button-stack flex col' role='group'>
                {question.input.options.map(opt => (
                  <React.Fragment key={opt}>
                    <input
                      type='radio'
                      name={question.messages[0].id}
                      id={opt}
                      checked={value === opt}
                      onChange={() => setValue(opt)}
                    />
                    <label htmlFor={opt}>{opt}</label>
                  </React.Fragment>
                ))}
              </div>
            )}

            {question?.input.type === 'checkbox' && (
              <div className='button-tag' role='group'>
                {question.input.options.map(opt => (
                  <React.Fragment key={opt.label}>
                    <input
                      type='checkbox'
                      name={question.messages[0].id}
                      id={opt.label}
                      checked={value.includes(opt.label)}
                      onChange={() => toggleCheckbox(opt.label)}
                    />
                    <label htmlFor={opt.label}>{opt.label}</label>
                  </React.Fragment>
                ))}
              </div>
            )}

            {question?.input.type === 'number-group' && (
              <div className='number-group flex col' role='group'>
                {(() => {
                  const options = typeof question.input.options === 'function' ? question.input.options(answers) : question.input.options
                  const classOf = (label) => q_assets.input.options.find(o => o.label === label)?.class
                  let lastClass = null
                  return options.map(opt => {
                    const cls = classOf(opt)
                    const showHeading = cls !== lastClass
                    lastClass = cls
                    return (
                      <React.Fragment key={opt}>
                        {showHeading && <p className='number-group-heading'>{CLASS_LABELS[cls]}</p>}
                        <div className='flex row space center'>
                          <label htmlFor={opt}>{opt}</label>
                          <input
                            type='number'
                            id={opt}
                            value={value[opt]}
                            onChange={e => setNumberGroupValue(opt, e.target.value)}
                            placeholder='0'
                          />
                        </div>
                      </React.Fragment>
                    )
                  })
                })()}
              </div>
            )}

             <button type='submit'><PaperPlaneIcon size={18} /></button>


          </form>
   
      </div>
    </div>
  )
}

export default OnboardingModal
